import { render } from "./scoreShow.vue?vue&type=template&id=6048f6f7&scoped=true"
import script from "./scoreShow.vue?vue&type=script&lang=js"
export * from "./scoreShow.vue?vue&type=script&lang=js"

import "./scoreShow.vue?vue&type=style&index=0&id=6048f6f7&scoped=true&lang=less"

import exportComponent from "/dev/shm/repo/piano-dp60u5626l1a/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6048f6f7"]])

export default __exports__